<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YJ81vD/tc-custom/9781626813502.jpg?1726574237469" alt="This image is the cover for the book Parts Unknown, The Alex Shanahan Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Parts Unknown, The Alex Shanahan Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>Black market airplane parts put countless lives at risk in this terrifying thriller: “The best white-knuckle ride I’ve taken in a long time” (Lee Child).</b><br/>  <br/> Alex Shanahan has accepted a new job with a Detroit start-up airline when the death of her friend John McTavish takes her on a detour to Miami. But her trip turns perilous when Alex connects John’s murder to the lucrative world of black-market airplane parts.<br/>  <br/> Now Alex must walk into the darkest corner of the business she loves, where profits are valued over the lives of a planeload of passengers—and murder is the solution when millions are at stake. In a world where one faulty part can bring down an airline and catastrophe is an acceptable risk, Alex must tread carefully, because every step she takes could be her last.<br/>  <br/> “Fast-moving and as fascinating as a natural disaster, the novel is suspenseful and electric and has the appeal of an insider story. Ms. Heitman is a former airline employee of fourteen years, and her words ring true.” —<i>The Dallas Morning News</i><br/>  <br/> “An intricate and explosive thriller . . . One of the year’s most notable.” —<i>Publishers Weekly</i><br/>  <br/> “Heitman melds the maze of today’s airline industry with intrigue and mystery.” —John Nance<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynne Heitman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6540050a